import { render, staticRenderFns } from "./UserManageGrid.vue?vue&type=template&id=70ff43b1&"
import script from "./UserManageGrid.vue?vue&type=script&lang=js&"
export * from "./UserManageGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports